import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/layout/header/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/ui/Button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/ui/InstallPrompts.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/content/components/ActivityCarousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/content/components/AdvertisementCarousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/content/components/AdvertisingImage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/content/components/MainSearch.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
